import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AumicoCompaniesConfigService } from '../aumico-companies.config';
import { IZefixCompanyDTO } from '../dtos/zefix-company.dto';

@Injectable({
    providedIn: 'root',
})
export class ZefixService {
    private readonly base = 'internal/zefix';

    constructor(
        private http: HttpClient,
        @Inject(AumicoCompaniesConfigService) private config,
    ) {}

    /** Search by name or UID — BE auto-detects the mode */
    search(query: string): Observable<IZefixCompanyDTO[]> {
        const params = new HttpParams().set('q', query);
        return this.http.get<IZefixCompanyDTO[]>(`${this.config.apiGateway}${this.base}/search`, { params });
    }

    /** Fetch full company details by UID (format: CHE107721785 — no dashes/dots) */
    getCompanyByUid(uid: string): Observable<IZefixCompanyDTO> {
        const normalizedUid = uid.replace(/[-\.]/g, '');
        return this.http.get<IZefixCompanyDTO>(
            `${this.config.apiGateway}${this.base}/uid/${encodeURIComponent(normalizedUid)}`,
        );
    }

    /** Refresh — fetch latest Zefix data for an already-linked company */
    refresh(uid: string): Observable<IZefixCompanyDTO> {
        const normalizedUid = uid.replace(/[-\.]/g, '');
        const params = new HttpParams().set('uid', normalizedUid);
        return this.http.get<IZefixCompanyDTO>(`${this.config.apiGateway}${this.base}/refresh`, { params });
    }
}
